var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboundCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#4A505B",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5498 6.83987C10.253 6.84289 10 7.08565 10 7.39847V10.7129L7.54199 10.0655L7.19824 9.13968C7.15574 9.02618 7.05893 8.94109 6.94043 8.91409C6.71543 8.86259 6.5 9.03415 6.5 9.26565V10.5713C6.5 11.0248 6.80564 11.4221 7.24414 11.5381L14.5742 13.4815V13.4795C14.6318 13.4936 14.6908 13.5008 14.75 13.501C14.9489 13.501 15.1397 13.422 15.2803 13.2813C15.421 13.1407 15.5 12.9499 15.5 12.751C15.5 12.5767 15.4392 12.4078 15.3282 12.2735C15.2171 12.1391 15.0628 12.0476 14.8916 12.0147L12.3945 11.3467L11.0889 7.22952C11.0289 7.04052 10.8732 6.89705 10.6797 6.85355C10.6361 6.84373 10.5922 6.83944 10.5498 6.83987ZM7 15.001C6.724 15.001 6.5 15.225 6.5 15.501C6.5 15.777 6.724 16.001 7 16.001H15C15.276 16.001 15.5 15.777 15.5 15.501C15.5 15.225 15.276 15.001 15 15.001H7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboundCircle);
export default __webpack_public_path__ + "static/media/inbound_circle.10acdd6ea85becbbc4bf0361da08bb6c.svg";
export { ForwardRef as ReactComponent };